import axiosInstance from "../axiosInstance";

export const catalogService = {
  create: async (data) => {
    try {
      const response = await axiosInstance.post("/catalog", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (client_id, searchValue, query, signal) => {
    try {
      let api = `/catalog?$populate=type&$populate=client_id&$select[]=name&$select[]=type&$select[]=valid_from&$select[]=valid_till&$select[]=type&$select[]=uid&$select[]=print_date`;
      if (client_id) api += `&client_id=${client_id}`;
      if (searchValue) api += `&name[$search]=${searchValue}`;
      if (query && query.length) api += `&${query}`;
      if (!query || !query.includes("$sort")) api += `&$sort[createdAt]=-1`;
      const response = await axiosInstance.get(api, signal);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchById: async (id) => {
    try {
      const response = await axiosInstance.get(
        `/catalog/${id}?$populate[1][path]=type&$populate[0][path]=client_id&$populate[0][select][0]=name`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (data, id) => {
    try {
      const response = await axiosInstance.patch(`/catalog/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/catalog/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchNames: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `/catalog?$limit=${limit}&$skip=${skip}&$select[]=name&$sort[name]=1&$select[]=uid`;
      if (client_id) query += `&client_id=${client_id}`;
      if (searchKey) query += `&name[$search]=${searchKey}`;
      const response = await axiosInstance.get(query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
